export enum NavHelpAction {
	ROTATE = 'rotate',
	QR = 'qr',
	HELP = 'help',
	VOLUMEN = 'volume',
	LANGUAGE = 'language',
}
